import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import Moment from "moment";
import {getFireStatus, getRealtimeFire} from "../api/apiClient";
import DateFacilityFireSearchBox from "../components/searchBoxs/DateFacilityFireSearchBox";
import TableFireStatus from "../components/tables/TableFireStatus";

const DashFireStatus = ({propAuth}) => {

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 검색 조건
  let dtNow = new Date();
  let strNowHour = Moment(dtNow).format('HH');
  let dtYesterday = new Date();
  dtYesterday.setDate(dtNow.getDate() - 1);
  let strYesterdayHour = Moment(dtYesterday).format('HH')

  const [searchParam, setSearchParam] = useState({
    startDate: dtYesterday,
    startHour: strYesterdayHour,
    endDate: dtNow,
    endHour: strNowHour,
    fclty_cd: '',
    fire_status: '',
  });
  // 검색 버튼 클릭했는지
  const [isSearch, setIsSearch] = useState(true);

  const updateList = () => {
    // console.log(searchParam)
    getFireStatus(currentPage, listPageSize,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.fclty_cd,
        searchParam.fire_status)
        .then(res => {
          // console.log(res)
          if (res.data.data !== undefined) {
            setTableList(res.data.data.list);
            setTotal(res.data.data.total);
          }
        });
  };

  const updateFire = () => {
    if (sessionStorage.getItem('ACCESS_TOKEN') != null) {
      getRealtimeFire()
          .then((res) => {
            if (res.data.data.list.length > 0) {
              updateList();
            }
          });
    }
  };

  useEffect(() => {
    setIsSearch(false);

    /*let fireInterval = setInterval(updateFire, 10000);
    return () => {
      clearInterval(fireInterval);
    }*/
  }, []);

  useEffect(() => {
    updateList();
  }, [isSearch, currentPage, listPageSize]);


  return (
      <>
        <Container fluid className={""}>
          <Row className={"p-3"}>
            <Col md={12} className={"search-container py-2"}>
              <DateFacilityFireSearchBox
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  updateList={updateList}
                  setCurrentPage={setCurrentPage}
              />
            </Col>
            <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
              <TableFireStatus
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  listPageSize={listPageSize}
                  setListPageSize={setListPageSize}
                  total={total}
                  tableList={tableList}
                  updateList={updateList}
                  setIsSearch={setIsSearch}
                  setTableList={setTableList}
                  setTotal={setTotal}
                  searchParam={searchParam}
                  propAuth={propAuth}
              />
            </Col>
          </Row>
        </Container>
      </>
  );
};

export default DashFireStatus;
